import React from "react";
import Navbar from "./Navbar";
import { OnGoingContext } from "./ProjectContext/OnGoingContext";
import { FullStackContext } from "./ProjectContext/FullStackContext";
import { UIDContext } from "./ProjectContext/UIdesignContext";
import { useContext } from "react";
import Code from "../assets/generalicons/code.png";

const Project = ({ match }) => {
  const onGoing = useContext(OnGoingContext);
  const fullstack = useContext(FullStackContext);
  const uidesign = useContext(UIDContext);

  let projectdetails = onGoing.filter(
    (ongoing) => ongoing.id === match.params.id
  );
  if (projectdetails.length === 0)
    projectdetails = fullstack.filter(
      (fullstack) => fullstack.id === match.params.id
    );
  console.log(projectdetails);
  if (projectdetails.length === 0)
    projectdetails = uidesign.filter(
      (uidesign) => uidesign.id === match.params.id
    );
  return (
    <React.Fragment>
      <div className="container">
        <Navbar />
        {projectdetails.map((project) => (
          <div key={project.id}>
            <h4 className="ml-4 mb-4">{project.name}</h4>
            <p className="ml-4 mb-4"> {project.description}</p>
            <a
              href={project.code}
              className="ml-4 mb-4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Code}
                alt="code"
                height="15px"
                style={{ paddingRight: "10px" }}
              />
              Code
            </a>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default Project;
